import store from "@/core/services/store";

let unwatchPresentation = null;

/**
 * O borrao acompanha `dadosMascarados`, e nao mais so o botao (WEL-5344).
 *
 * Eu havia desligado o borrao quando o motor esta ativo, com o argumento de que
 * o servidor ja cobre e borrar por cima devolveria a tela ilegivel. O argumento
 * vale para o `conteudo` do relatorio, que nao usa esta diretiva; nao vale para
 * os 20 e poucos pontos que a usam, porque varios deles NAO passam pelo motor.
 * O cabecalho e o caso obvio: o nome e a conta vem do verificar-login, que esta
 * fora do escopo do middleware por decisao, entao ficaram totalmente expostos.
 *
 * Quem marcou um elemento com esta diretiva escolheu escondê-lo, e a escolha
 * continua valendo. O que mudou e o gatilho: antes era so o botao, agora e o
 * estado real de protecao, entao o borrao aparece desde o logon, sem depender
 * de o usuario lembrar de ativar.
 */
const updatePresentationClass = () => {
  if (typeof document === "undefined") return;

  document.documentElement.classList.toggle(
    "presentation-mode-active",
    store.getters["cobrirNoNavegador"]
  );
};

const ensurePresentationWatcher = () => {
  if (unwatchPresentation || typeof document === "undefined") return;

  updatePresentationClass();

  // Observa o getter, e nao o estado local: a protecao tambem muda quando a
  // liberacao do servidor entra ou expira, sem ninguem tocar no botao.
  unwatchPresentation = store.watch(
    () => store.getters["cobrirNoNavegador"],
    updatePresentationClass
  );
};

/**
 * Mantem as ABAS em acordo (WEL-5344).
 *
 * O estado de cobrir fica no localStorage, que e compartilhado entre abas, mas
 * cada aba guarda a propria copia em memoria e so a aba que clicou recarregava.
 * O efeito era o pior possivel para o caso de uso: o operador manda ocultar
 * antes de compartilhar a tela, e a aba aberta atras continua exibindo o dado
 * real, porque ela pediu os dados sem o cabecalho e ninguem a avisou.
 *
 * A reacao e assimetrica de proposito. Indo para MAIS protecao, a aba recarrega
 * sozinha, porque o dado que ela ja tem em tela veio descoberto e precisa ser
 * pedido de novo. Indo para MENOS, so o estado e sincronizado: recarregar a
 * forca uma aba onde alguem talvez esteja preenchendo um formulario, para
 * revelar dado, seria trocar trabalho perdido por conveniencia.
 */
const ouvirOutrasAbas = () => {
  if (typeof window === "undefined") return;

  window.addEventListener("storage", (evento) => {
    if (evento.key !== "presentationMode") return;

    const cobrir = evento.newValue === "true";

    store.dispatch("setPresentationMode", cobrir);

    if (cobrir) {
      window.location.reload();
    }
  });
};

ensurePresentationWatcher();
ouvirOutrasAbas();

export default {
  bind(el) {
    /**
     * Mantem as ABAS em acordo (WEL-5344).
     *
     * O estado de cobrir fica no localStorage, que e compartilhado entre abas, mas
     * cada aba guarda a propria copia em memoria e so a aba que clicou recarregava.
     * O efeito era o pior possivel para o caso de uso: o operador manda ocultar
     * antes de compartilhar a tela, e a aba aberta atras continua exibindo o dado
     * real, porque ela pediu os dados sem o cabecalho e ninguem a avisou.
     *
     * A reacao e assimetrica de proposito. Indo para MAIS protecao, a aba recarrega
     * sozinha, porque o dado que ela ja tem em tela veio descoberto e precisa ser
     * pedido de novo. Indo para MENOS, so o estado e sincronizado: recarregar a
     * forca uma aba onde alguem talvez esteja preenchendo um formulario, para
     * revelar dado, seria trocar trabalho perdido por conveniencia.
     */
    const ouvirOutrasAbas = () => {
      if (typeof window === "undefined") return;

      window.addEventListener("storage", (evento) => {
        if (evento.key !== "presentationMode") return;

        const cobrir = evento.newValue === "true";

        store.dispatch("setPresentationMode", cobrir);

        if (cobrir) {
          window.location.reload();
        }
      });
    };

    ensurePresentationWatcher();
    ouvirOutrasAbas();
    el.classList.add("presentation-blur-target");
  },
  unbind(el) {
    el.classList.remove("presentation-blur-target");
  }
};
